import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
    nameComponent: PropTypes.string,
    secondaryTitle:  PropTypes.string,
    index: PropTypes.number,
    active: PropTypes.bool,
    completed: PropTypes.bool,
    first: PropTypes.bool,
    isLast: PropTypes.bool,
    href: PropTypes.string,
    onClick: PropTypes.func,
};


export default class StepV extends React.Component{
    constructor(props){
        super(props);

    }

    render() {
        const{nameComponent, completeTitle, index, completed, isLast, first, imgSrc} = this.props;

        const circleText = index + 1;

        let circleClasses = '';
        let numberClasses = '';

        if(this.props.first) {
            numberClasses = 'first';
        }

        if(this.props.completed) {
            circleClasses = 'v-circle-completed';
        }

        //add isLast step conditional for reCaptcha, when that is fixed!!


        return(
            <tr className='v-table-tr'>
                <td className={`step-number ${numberClasses}`}>
                    {isLast ?
                        <div className={`v-circle--style-last ${circleClasses}`}>{circleText}</div> :
                        <div className={`v-circle--style ${circleClasses}`}>{circleText}</div>
                    }
                </td>
                <td className='step-name'>
                        <div className='name-comp-hold'>{nameComponent}</div>
                </td>
                <td className='step-status'>
                    <img className='icon-check' src={imgSrc}></img>{completeTitle}
                </td>
            </tr>
        );
    }
}

StepV.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/StepperVertical/StepV.js